// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080905/js/" + chunkId + "." + {"44":"385ced81","225":"1ae6dc45","481":"cb4a3f54","486":"6280ab6a","770":"f45a159d"}[chunkId] + ".0.8283352781174091.chunk.js";
};